// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cDIZ","content":"styles_content__2F_NI","row":"styles_row__20nzs","footer":"styles_footer__1QQu8","phraseLength":"styles_phraseLength__1tKEl"};